// src/hr/kit/Pill.js -- small status / type label.
import React from 'react';
import { cx, parseHex, towardWhite } from './util';

export const PILL_TONES = ['pto', 'sick', 'personal', 'ok', 'warn', 'bad', 'mute'];

// tone: one of PILL_TONES. color: any hex (e.g. a custom time-off type) -- tints the pill and
// lifts the text toward white so it stays readable on the dark surface.
export function Pill({ tone = 'mute', color, dot = false, icon, title, className, children }) {
  const rgb = color ? parseHex(color) : null;
  const style = rgb
    ? { background: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.16)`, color: towardWhite(rgb, 0.62), '--hrp-dot': color }
    : undefined;
  const toneClass = rgb ? null : `hrp-pill--${PILL_TONES.includes(tone) ? tone : 'mute'}`;
  return (
    <span className={cx('hrp-pill', toneClass, className)} style={style} title={title}>
      {dot && <i className="hrp-pill__dot" aria-hidden="true" />}
      {icon && <span className="hrp-pill__ic" aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
}

export default Pill;
